<template>
    <div id="tetris-wrapper" v-on:keydown="keydown" v-on:keyup="keyup" ref="boardControl" tabindex="1">
        <a class="tetris__partners" target="_blank"
           @click="showPartners = true, document.body.classList.add('no-scroll')">
            <div class="tetris__desc">
                Партнерський <br> матеріал з
                <span class="tetris__why">Що це означає?</span>
            </div>
            <img :src="pathToImg+'/'+img.Logo" alt="" class="tetris__img">

        </a>
        <a href="https://hmarochos.kiev.ua/" class="tetris__logo">
            <img :src="pathToImg+'/'+img.LogoHmar" alt="" class="">
        </a>

        <div class="partnersinfo-wrapper" :class="{'active': showPartners === true}">
            <svg v-if="showPartners === true" @click="showPartners = false" class="partnersinfo__close" width="23px"
                 height="23px" viewBox="0 0 23 23" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="#fff" fill-rule="evenodd">
                    <rect transform="translate(11.313708, 11.313708) rotate(-45.000000) translate(-11.313708, -11.313708) "
                          x="10.3137085" y="-3.6862915" width="2" height="30"></rect>
                    <rect transform="translate(11.313708, 11.313708) rotate(-315.000000) translate(-11.313708, -11.313708) "
                          x="10.3137085" y="-3.6862915" width="2" height="30"></rect>
                </g>
            </svg>
            <transition name="fade">
                <div v-if="showPartners === true" class="partnersinfo__bg" @click="showPartners = false"></div>
            </transition>
            <transition name="fademove">
                <div class="partnersinfo" v-if="showPartners === true">
                    <a href="https://bit.ly/2VrMA3E">
                        <img :src="pathToImg+'/'+img.Logo" alt="" class="partnersinfo__img"></a>
                    <div class="partnersinfo__desc">
                        Це – спонсорський матеріал, вихід якого став можливим за фінансової підтримки партнера. Тема
                        статті
                        і текст розробляється з урахуванням його побажань.
                    </div>
                    <social-sharing :url="path"
                                    title="Зіграй у київський тетріс та збери найвідоміші будівлі!"
                                    inline-template>
                        <div class="social">
                            <network network="facebook">

                                <svg height="512pt" viewBox="0 0 512 512" width="512pt"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="m483.738281 0h-455.5c-15.597656.0078125-28.24218725 12.660156-28.238281 28.261719v455.5c.0078125 15.597656 12.660156 28.242187 28.261719 28.238281h455.476562c15.605469.003906 28.257813-12.644531 28.261719-28.25 0-.003906 0-.007812 0-.011719v-455.5c-.007812-15.597656-12.660156-28.24218725-28.261719-28.238281zm0 0"
                                          fill="#4267b2"/>
                                    <path d="m353.5 512v-198h66.75l10-77.5h-76.75v-49.359375c0-22.386719 6.214844-37.640625 38.316406-37.640625h40.683594v-69.128906c-7.078125-.941406-31.363281-3.046875-59.621094-3.046875-59 0-99.378906 36-99.378906 102.140625v57.035156h-66.5v77.5h66.5v198zm0 0"
                                          fill="#fff"/>
                                </svg>
                            </network>
                            <network network="twitter">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 455.731 455.731" style="enable-background:new 0 0 455.731 455.731;"
                                     xml:space="preserve">
<g>
	<rect x="0" y="0" style="fill:#50ABF1;" width="455.731" height="455.731"/>
    <path style="fill:#FFFFFF;" d="M60.377,337.822c30.33,19.236,66.308,30.368,104.875,30.368c108.349,0,196.18-87.841,196.18-196.18
		c0-2.705-0.057-5.39-0.161-8.067c3.919-3.084,28.157-22.511,34.098-35c0,0-19.683,8.18-38.947,10.107
		c-0.038,0-0.085,0.009-0.123,0.009c0,0,0.038-0.019,0.104-0.066c1.775-1.186,26.591-18.079,29.951-38.207
		c0,0-13.922,7.431-33.415,13.932c-3.227,1.072-6.605,2.126-10.088,3.103c-12.565-13.41-30.425-21.78-50.25-21.78
		c-38.027,0-68.841,30.805-68.841,68.803c0,5.362,0.617,10.581,1.784,15.592c-5.314-0.218-86.237-4.755-141.289-71.423
		c0,0-32.902,44.917,19.607,91.105c0,0-15.962-0.636-29.733-8.864c0,0-5.058,54.416,54.407,68.329c0,0-11.701,4.432-30.368,1.272
		c0,0,10.439,43.968,63.271,48.077c0,0-41.777,37.74-101.081,28.885L60.377,337.822z"/>
</g>
</svg>

                            </network>
                        </div>
                    </social-sharing>
                </div>

            </transition>
        </div>
        <div class="partnersinfo-wrapper " :class="{'active': finalWin === true}">
            <transition name="fade">
                <div v-if="finalWin === true" class="partnersinfo__bg"></div>
            </transition>
            <transition name="fademove">
                <perfect-scrollbar class="partnersinfo fin" v-if="finalWin === true">

                    <!--                    <a href="https://bit.ly/2VrMA3E">-->
                    <!--                        <img :src="img.Logo" alt="" class="partnersinfo__img"></a>-->
                    <div class="partnersinfo__desc">

                        <h2>Вітаємо, ви успішно пройшли гру!<br>
                            <p>
                                Час проходження: <span style="color:  #32c96f">{{+currentMin}}</span> хвилин <span
                                    style="color: #32c96f">{{currentSec}}</span> секунд
                            </p>
                        </h2>
                        <social-sharing :url="path"
                                        title="Зіграй у київський тетріс та збери найвідоміші будівлі!"
                                        inline-template>

                            <div class="social">
                                <div class="social__desc">Розкажіть про це друзям:</div>
                                <div class="social__netw">
                                    <network network="facebook">

                                        <svg height="512pt" viewBox="0 0 512 512" width="512pt"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="m483.738281 0h-455.5c-15.597656.0078125-28.24218725 12.660156-28.238281 28.261719v455.5c.0078125 15.597656 12.660156 28.242187 28.261719 28.238281h455.476562c15.605469.003906 28.257813-12.644531 28.261719-28.25 0-.003906 0-.007812 0-.011719v-455.5c-.007812-15.597656-12.660156-28.24218725-28.261719-28.238281zm0 0"
                                                  fill="#4267b2"/>
                                            <path d="m353.5 512v-198h66.75l10-77.5h-76.75v-49.359375c0-22.386719 6.214844-37.640625 38.316406-37.640625h40.683594v-69.128906c-7.078125-.941406-31.363281-3.046875-59.621094-3.046875-59 0-99.378906 36-99.378906 102.140625v57.035156h-66.5v77.5h66.5v198zm0 0"
                                                  fill="#fff"/>
                                        </svg>
                                    </network>
                                    <network network="twitter">
                                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                             viewBox="0 0 455.731 455.731"
                                             style="enable-background:new 0 0 455.731 455.731;"
                                             xml:space="preserve">
<g>
	<rect x="0" y="0" style="fill:#50ABF1;" width="455.731" height="455.731"/>
    <path style="fill:#FFFFFF;" d="M60.377,337.822c30.33,19.236,66.308,30.368,104.875,30.368c108.349,0,196.18-87.841,196.18-196.18
		c0-2.705-0.057-5.39-0.161-8.067c3.919-3.084,28.157-22.511,34.098-35c0,0-19.683,8.18-38.947,10.107
		c-0.038,0-0.085,0.009-0.123,0.009c0,0,0.038-0.019,0.104-0.066c1.775-1.186,26.591-18.079,29.951-38.207
		c0,0-13.922,7.431-33.415,13.932c-3.227,1.072-6.605,2.126-10.088,3.103c-12.565-13.41-30.425-21.78-50.25-21.78
		c-38.027,0-68.841,30.805-68.841,68.803c0,5.362,0.617,10.581,1.784,15.592c-5.314-0.218-86.237-4.755-141.289-71.423
		c0,0-32.902,44.917,19.607,91.105c0,0-15.962-0.636-29.733-8.864c0,0-5.058,54.416,54.407,68.329c0,0-11.701,4.432-30.368,1.272
		c0,0,10.439,43.968,63.271,48.077c0,0-41.777,37.74-101.081,28.885L60.377,337.822z"/>
</g>
</svg>

                                    </network>
                                </div>
                            </div>
                        </social-sharing>

                        <div class="fin__images">

                            <img :src="pathToImg+'/'+img.olimpfin" alt="">
                            <img :src="pathToImg+'/'+img.bibliofin" alt="">
                            <img :src="pathToImg+'/'+img.parusfin" alt="">
                            <img :src="pathToImg+'/'+img.tsumfin" alt="">
                            <img :src="pathToImg+'/'+img.vokzalfin" alt="">


                        </div>
                        <p>
                            Понад 60% будівель Києва зведено з використанням
                            <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетону від
                                Ковальської»</a>. Це –
                            знакові громадські об’єкти: НСК Олімпійський, Дарницький міст, модерністська
                            бібліотека ім. В. І. Вернадського, торговельні центри, бізнес-центри, термінали
                            аеропортів, вокзали й житло.
                        </p>
                        <p>
                            З бетоном працювали й ним захоплювалися кращі архітектори світу – від представників
                            школи Баухауз, інтернаціонального стилю, міжвоєнного та післявоєнного модернізму й
                            до сучасності. В Києві є унікальна спадщина у вигляді архітектури модернізму, а в
                            післявоєнний період з бетону зводилися й цілі житлові райони.
                        </p>
                        <p>
                            Група компаній <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Ковальська»</a>
                            працює на українському ринку шістдесят чотири роки й за
                            цей час стала номером один серед виробників бетонних сумішей України. Про якість
                            бетону говорить, перш за все, довговічність будівель, які зводяться. Адже бетон – це
                            основа будь-якого будинку. Якщо зробити неякісні перекриття, страждатиме весь дім –
                            протікатиме стеля, псуватиметься внутрішнє оздоблення.</p>
                        <p>

                            Не залежно від того, чи ви самостійно зводите своє житло, інвестуєте у квартиру в
                            новобудові чи задіяні у створенні інфраструктурного об’єкта – вибір бетону має
                            відбуватися ретельно. Важливо, хто виробник бетону, яка його якість. <a
                                href="https://kovalska.com/beton-vid-kovalskoyi"
                                target="_blank">«Ковальська»</a>
                            має
                            сертифікати якості від всіх виробників на всі матеріали своїх заводів. Є три ключові
                            показники бетону, які потрібно перевіряти раз в півроку й компанія чи не єдина в
                            Україні, хто здійснює весь контроль, попри те, що це – складна й затратна процедура.
                        </p>
                        <p>
                            Широкий асортимент матеріалів дозволяє реалізувати будь-які архітектурні задуми.
                            <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Ковальська»</a>
                            виготовляє власні добавки і може змінювати їхній склад, що дозволяє швидко
                            розробляти нові рішення – розробити бетон за індивідуальним замовленням можуть
                            протягом тижня.
                        </p>
                        <p>

                            Також у «<a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">Ковальської</a>»
                            є власний парк бетономішалок. Їх можна часто побачити на вулицях
                            Києва, адже завдяки «міксерам» бетон оперативно доставляється у будь-яку точку міста.

                        </p>
                        <button @click="step = 1, finalWin = false, gameon = false, win = false, currentMin = '00', currentSec='00', currentTime.setMinutes(0,0),  document.body.classList.remove('no-scroll')"
                                class="tetris__nextbutton">Грати спочатку
                        </button>
                    </div>
                </perfect-scrollbar>

            </transition>
        </div>


        <div id="tetrishold">
            <div id="tetris"></div>

            <div class="game" v-show="state !== 'settings'">

                <!--                {{score}}/{{finScore[step-1]}}-->

                <div class="main" v-bind:style="{'--brickSize': brickSize+'vh'}">

                    <div class="hiddenimages">
                        <div class="board biblio">
                        <div class="prev"></div>
                    </div>
                        <div class="board vokzal">
                            <div class="prev"></div>
                        </div>
                        <div class="board tsum">
                            <div class="prev"></div>
                        </div>
                        <div class="board olimp">
                            <div class="prev"></div>
                        </div>
                        <div class="board parus">
                            <div class="prev"></div>
                        </div>
                        <img :src="img.olimpfin" alt="">
                        <img :src="img.parusfin" alt="">
                        <img :src="img.bibliofin" alt="">
                        <img :src="img.tsumfin" alt="">
                        <img :src="img.vokzalfin" alt="">
                    </div>

                    <div class="left">
                        <img :src="pathToImg+'/'+img.betonomeshalka" alt="" class="betonomeshalka" v-if="start">
                        <!--                        <img :src="img.betonomeshalkastop" alt="" class="betonomeshalka" v-if="!showAnimation">-->
                        <div class="firstscreen" v-if="!gameon && !win && !start">
                            <div v-if="instructions===false">

                                <h2 class="firstscreen__header">
                                    Зіграйте у київський тетріс!
                                </h2>
                                <div class="firstscreen__desc">
                                    <p>Збирайте найвідоміші об’єкти і дізнавайтеся їхню історію.</p>
                                    <!--                               <p> В грі п’ять рівнів, від найпростішого – до складного. Потрібно зібрати простір навколо-->
                                    <!--                                кожної будівлі. Рівень закінчується, коли об’єкт опускається вниз, а ви переходите до-->
                                    <!--                                наступного етапу.</p>-->
                                </div>
                                <button class="tetris__nextbutton" @click="instructions=true">Почати гру</button>
                            </div>
                            <div v-if="instructions===true">
                                <div class="firstscreen__desc bigletter">
                                    <p> В грі п’ять рівнів, від найпростішого – до складного. Потрібно зібрати простір
                                        навколо
                                        кожної будівлі. Рівень закінчується, коли об’єкт опускається вниз, а ви
                                        переходите до
                                        наступного етапу.
                                        Тисніть вліво, вправо, перевернути й прискорити, щоб управляти блоками.
                                    </p>
                                </div>
                                <button class="tetris__nextbutton" @click="start=true, gameon= true">Грати!</button>
                            </div>
                        </div>
                        <div class="tetrisboard" v-if=" gameon && start  && !win">
                            <tetris-board class="board vokzal" v-model="board" ref="board"
                                          v-if="step===1" ></tetris-board>
                            <tetris-board class="board olimp" v-model="board" ref="board"
                                          v-if="step===2"></tetris-board>
                            <tetris-board class="board tsum" v-model="board" ref="board" v-if="step===3"></tetris-board>

                            <tetris-board class="board biblio" v-model="board" ref="board"
                                          v-if="step===4"></tetris-board>
                            <tetris-board class="board parus" v-model="board" ref="board" v-if="step===5" ></tetris-board>

                        </div>
                        <perfect-scrollbar class="winner" v-if="gameon && !start && win">
                            <div v-if="step === 1">
                                <h2 class="win__header">
                                    Вокзал «Південний» в Києві
                                </h2>
                                <img :src="pathToImg+'/'+img.vokzalfin" alt="">
                                <p> Південний вокзал відкрили в 2001 році, раніше на його місці розташовувався оптовий
                                    ринок.
                                    Архітектурні рішення нової будівлі були настільки незвичними для того часу, що після
                                    відкриття
                                    сюди
                                    водили шкільні екскурсії.
                                </p>
                                <p>
                                    Під час будівництва Південного вокзалу використовували <a
                                        href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетон від
                                    Ковальської»</a>.
                                    Група компаній
                                    <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Ковальська»</a>
                                    має надзвичайно великі потужності – до 1000 куб м на годину, й може забезпечити
                                    необхідною кількістю матеріалів для зведення наймасштабніших об’єктів.
                                </p>
                            </div>
                            <div v-if="step === 2">
                                <h2 class="win__header">
                                    НСК Олімпійський
                                </h2>
                                <img :src="pathToImg+'/'+img.olimpfin" alt="">
                                <p> На НСК Олімпійський відбувалися футбольні матчі Олімпійських ігор в 1980 році,
                                    Євро-2012, а в 2018 – фінал Ліги чемпіонів УЄФА.
                                    Впродовж свого існування стадіон змінив декілька назв. Носив ім’я Хрущова, був
                                    Київським центральним стадіоном, а згодом – Республіканським.

                                </p>
                                <p>
                                    Спортивний комплекс незмінно працює з 1923 року. Під час його реконструкції до
                                    ЄВРО-2012 використовували <a
                                        href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетон від
                                    Ковальської»</a>.
                                    З нього створювали сходові клітини,
                                    стінові панелі й загалом використали понад 1 000 кубічних метрів конструктиву.
                                </p>
                                <p>
                                    Бетон <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«ПБГ
                                    Ковальська»</a> має понад 1500 рецептур виробів й вирізняється довговічністю, на
                                    кожну партію сировини є окремий сертифікат якості.
                                </p>
                            </div>
                            <div v-if="step === 3">
                                <h2 class="win__header">
                                    ЦУМ
                                </h2>
                                <img :src="pathToImg+'/'+img.tsumfin" alt="">
                                <p>
                                    Київський центральний універмаг збудований у стилі ар-деко. ЦУМ відкрили для перших
                                    відвідувачів
                                    у 1939 році. Це – одна з небагатьох будівель на Хрещатику, яка не була повністю
                                    зруйнована у
                                    ході Другої світової й знову почала працювати у 1947 році після реконструкції. Це –
                                    перший
                                    магазин в Україні, де встановили ескалатор, ще в 1960 році. Тривалий час ЦУМ
                                    слугував
                                    символом
                                    «радянського достатку».
                                </p>
                                <p>
                                    В 2016 році універмаг реконструювали. В ході будівельних робіт використовували
                                    <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетон від
                                        Ковальської»</a>.
                                    Під куполом оновленої будівлі розташовані ресторани, кафе та бари з мальовничим
                                    видом на старий Київ.
                                </p>
                            </div>
                            <div v-if="step === 4">
                                <h2 class="win__header">
                                    Національна бібліотека України ім. В.І. Вернадського
                                </h2>
                                <img :src="pathToImg+'/'+img.bibliofin" alt="">
                                <p>
                                    Бібліотека імені Вернадського – найбільша в Україні. Її відкрили в 1989 році, а на
                                    церемонію
                                    приїхав сам Борис Патон, президент НАН України. Один з її корпусів сягає 77 метрів
                                    заввишки
                                    і
                                    виконаний в стилі архітектури модернізму.
                                </p>
                                <p>
                                    Бібліотека складається з вертикальної споруди, де знаходяться книгосховища, й
                                    стилобату – з
                                    читальними залами, конференц залою та службовими приміщеннями.
                                </p>
                                <p>
                                    Її зводили за кресленнями «Київпроекту», а в ході будівництва використовували
                                    <a href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетон від
                                        Ковальської»</a>.
                                </p>
                                <p>
                                    <a href="https://kovalska.com/beton-vid-kovalskoyi"
                                       target="_blank">ПБГ «Ковальська»</a> має власну сертифіковану лабораторію,
                                    фахівці
                                    якої на кожному етапі
                                    перевіряють
                                    якість продукції і так само працюють над новими вдосконаленими рецептурами. Все це
                                    гарантує
                                    довговічність і надійність спорудам, зведених з <a
                                        href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">«Бетону від
                                    Ковальської»</a>.
                                </p>
                            </div>
                            <div v-if="step === 5">
                                <h2 class="win__header">
                                    БЦ Парус
                                </h2>
                                <img :src="pathToImg+'/'+img.parusfin" alt="">
                                <p>
                                    БЦ Парус є однією з найвищих будівель Києва і сягає 133 метрів у висоту. Бізнес
                                    центр має 32
                                    поверхи й будувався впродовж трьох років.
                                    Будівлю зводили з використанням скла, сталі, алюмінію, бетону, залізобетону й цегли.
                                    У ході
                                    робіт використовували матеріали від <a
                                        href="https://kovalska.com/beton-vid-kovalskoyi" target="_blank">ПБГ
                                    «Ковальська»</a>.
                                </p>
                            </div>



                        </perfect-scrollbar>
                        <div class="loose" v-if="gameon && !start && !win">
                            <h2 class="loose__header">
                                Вам не вдалося збудувати {{nameObject[step-1]}} :(
                            </h2>
<!--                            <button class="tetris__nextbutton" @click="start =true">Спробуйте ще раз!</button>-->
                        </div>
                        <div class="tetris__nav" >
                            <button class="tetris__nextbutton" @click="nextLevel()" v-if="gameon && !start && win">Далі!</button>
                            <button class="tetris__nextbutton" v-if="gameon && !start && !win" @click="start =true">Спробуйте ще раз!</button>
                        <div class="tetris__rule" v-if="!gameon || start">
                            <div @click="move(-1)" role="button">
                                <svg version="1.1"
                                     viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;"
                                     xml:space="preserve">
		<path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
			C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
			c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
			l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/>
</svg>

                            </div>
                            <div @click="move(1)" role="button">
                                <svg x="0px" y="0px" viewBox="0 0 451.846 451.847"
                                     style="enable-background:new 0 0 451.846 451.847;"
                                     xml:space="preserve">
	<path d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"/>
</svg>

                            </div>
                            <div @click="rotate(1)" role="button">
                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                     viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;"
                                     xml:space="preserve">
		<g>
			<path d="M464.9,284.408c0.053,0,0.105,0.004,0.157,0.004h0.055L464.9,284.408z"/>
            <path d="M484.004,292.48c-5.063-5.086-11.821-8.025-18.947-8.068H330.468c-14.824,0-26.676,12.3-26.676,27.12v22.78
				c0,7.156,2.7,13.9,7.788,18.992c5.088,5.092,11.784,7.896,18.94,7.896l39.052,0.008c-32.06,34.332-76.68,53.864-123.672,53.864
				c-93.22,0-169.072-75.844-169.072-169.072s75.84-169.072,169.064-169.072c69.796,0,133.336,43.82,158.108,109.04
				c5.632,14.816,20.068,24.776,35.916,24.776c4.66,0,9.248-0.848,13.632-2.52c19.8-7.516,29.784-29.748,22.26-49.544
				C439.772,63.84,347.376,0.112,245.888,0.112C110.308,0.112,0,110.416,0,246s110.236,245.888,245.816,245.888
				c62.584,0,123.272-24.632,169.364-67.872v21.788c0,14.824,12.208,26.812,27.032,26.812h22.78
				c14.824,0,27.008-11.988,27.008-26.812v-134.18C492,304.444,489.116,297.564,484.004,292.48z"/></g>
</svg>

                            </div>
                            <div @click="moveDown" role="button">
                                <svg
                                        viewBox="0 0 491.996 491.996" style="enable-background:new 0 0 491.996 491.996;"
                                        xml:space="preserve">
		<path d="M484.132,124.986l-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86c-7.208,0-13.964,2.792-19.036,7.86l-183.84,183.848
			L62.056,108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968,2.788-19.036,7.856l-16.12,16.128
			c-10.496,10.488-10.496,27.572,0,38.06l219.136,219.924c5.064,5.064,11.812,8.632,19.084,8.632h0.084
			c7.212,0,13.96-3.572,19.024-8.632l218.932-219.328c5.072-5.064,7.856-12.016,7.864-19.224
			C491.996,136.902,489.204,130.046,484.132,124.986z"/>
</svg>
                            </div>
                        </div></div>
                    </div>
                    <div class="info" v-if="start===true">
                        <tetris-board class="preview" v-model="preview" ref="preview"></tetris-board>
                        <!--                    score: {{ score }}<br/>high score: {{ highScore }}<br/>speed: {{ speed }}<br/>-->
                        <!--                    <button v-on:click="newGame()"><u>n</u>ew</button>-->
                        <!--                    <button v-if="state === 'running'" v-on:click="pause()"><u>p</u>ause</button>-->
                        <!--                    <button v-else v-on:click="pause()"><u>p</u>lay</button>-->


                        <!--                    <button v-else v-on:click="pause()"><u>p</u>lay</button>-->
                        <!--                    <button v-else v-on:click="pause()"><u>p</u>lay</button>-->
                        <!--                    <button v-else v-on:click="pause()"><u>p</u>lay</button>-->
                        <!--                    <button v-else v-on:click="pause()"><u>p</u>lay</button>-->
                    </div>
                    <div class="info info-timer" v-if="start===true">
                        {{currentMin}}:{{currentSec}}
                    </div>
                    <!--                <div class="text-info" style="clear:both;">-->
                    <!--                    size: {{ board.w }}x{{ board.h }}-->
                    <!--                </div>-->
                </div>
            </div>

            <!--        <div class="settings" v-show="state === 'settings'">-->
            <!--            <div style="display: inline-block; vertical-align: top;">-->
            <!--                <table>-->
            <!--                    <tr>-->
            <!--                        <td colspan="2">-->
            <!--                            <button v-on:click="newGame()">new</button>-->
            <!--                        </td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td>brick size</td>-->
            <!--                        <td><input type="number" v-model="brickSize" min="4" max="32"/></td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td>width</td>-->
            <!--                        <td><input type="number" v-model="board.w" min="5" max="20"/></td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td>height</td>-->
            <!--                        <td><input type="number" v-model="board.h" min="5" max="40"/></td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td>speed</td>-->
            <!--                        <td><input type="number" v-model="speed" min="1" max="12"/></td>-->
            <!--                    </tr>-->
            <!--                    <tr>-->
            <!--                        <td title="no repeat figures, repeat all figures and set * 2">smart rand</td>-->
            <!--                        <td><input type="checkbox" v-model="smartRandom"/></td>-->
            <!--                    </tr>-->
            <!--                </table>-->
            <!--                <div class="figures" style="display: inline-block;">-->
            <!--                    figures<br/>-->
            <!--                    <table>-->
            <!--                        <tr>-->
            <!--                            <th>-->
            <!--                                <input type="checkbox" v-on:click="toggleFigures"/>off-->
            <!--                            </th>-->
            <!--                            <th>name</th>-->
            <!--                            <th>rot. mode</th>-->
            <!--                        </tr>-->
            <!--                        <tr v-for="(f, index) in figuresAll" :key="index">-->
            <!--                            <td><input type="checkbox" v-model="f.disabled"/></td>-->
            <!--                            <td>{{ f.name }}</td>-->
            <!--                            <td>{{ f.mode }}</td>-->
            <!--                        </tr>-->
            <!--                    </table>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </div>-->

        </div>
    </div>
</template>

<script>
    import TetrisBoard from "./TetrisBoard";
    import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
    import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
    import puzzleBg from "../assets/img/puzzlebg.jpeg";
    import vokzalfin from "../assets/img/vokzalfin.png";
    import olimpfin from "../assets/img/olimpfin.png";
    import tsumfin from "../assets/img/tsumfin.png";
    import bibliofin from "../assets/img/bibliofin.png";
    import parusfin from "../assets/img/parusfin.png";
    import facebookImg from "../assets/img/facebook.svg";
    import twitterImg from "../assets/img/twitter.svg";
    import betonomeshalka from "../assets/img/betonomeshalka.png";
    import betonomeshalkastop from "../assets/img/betongif.jpeg";
    import '../sass/main.scss';
    import 'reset-css';
    import Logo from "../assets/img/logo.png";
    import LogoHmar from "../assets/img/logohmar.png";
    import Vue from 'vue';

    var SocialSharing = require('vue-social-sharing');
    Vue.use(SocialSharing);
    let myPathToImg;
    if (document.getElementById('path')) {
        myPathToImg = document.getElementById('path').dataset.path;
    } else {
        myPathToImg = './'
    }

    export default {
        name: "Tetris",
        data: function () {
            return {
                state: 'running',
                figuresAll: [
                    {
                        name: 'line',
                        points: [[0, 0], [1, 0], [2, 0], [3, 0],],
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        mode: '90',
                        color: 'active',
                        image: puzzleBg
                    },
                    {
                        name: 'box',
                        points: [[0, 0], [0, 1], [1, 0], [1, 1],],
                        mode: 'frozen',
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    {
                        name: 'T',
                        points: [[0, 0], [1, 0], [2, 0], [1, 1],],
                        mode: 'rot',
                        anchor: [1, 0],
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    {
                        name: 'dog',
                        points: [[0, 0], [1, 0], [1, 1], [2, 1],],
                        mode: '90',
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    {
                        name: 'dog reverse',
                        points: [[0, 1], [1, 1], [1, 0], [2, 0],],
                        mode: '90',
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    {
                        name: 'L',
                        points: [[0, 0], [0, 1], [0, 2], [1, 2],],
                        mode: 'rot',
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    {
                        name: 'L reverse',
                        points: [[1, 0], [1, 1], [1, 2], [0, 2],],
                        mode: 'rot',
                        color: 'active',
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                        image: puzzleBg
                    },
                    // http://old.absolutist.com/tetris/tetris.html
                    {
                        name: 'L',
                        points: [[0, 0], [0, 1], [0, 2], [1, 2], [2, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'T',
                        points: [[0, 0], [1, 0], [2, 0], [1, 1], [1, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'W',
                        points: [[2, 0], [1, 1], [2, 1], [0, 2], [1, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'X',
                        points: [[1, 0], [0, 1], [1, 1], [2, 1], [1, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'U',
                        points: [[0, 1], [1, 1], [2, 1], [0, 0], [2, 0],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'Z',
                        points: [[0, 0], [1, 0], [1, 1], [1, 2], [2, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'F',
                        points: [[1, 0], [2, 0], [0, 1], [1, 1], [1, 2],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'P',
                        points: [[0, 0], [1, 0], [0, 1], [1, 1], [0, 2]],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'I',
                        points: [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'N',
                        points: [[0, 0], [0, 1], [1, 0], [1, 1], [0, 2], [0, 3],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'Y',
                        points: [[0, 1], [1, 0], [1, 1], [1, 2], [1, 3],],
                        mode: 'rot',
                        color: '#afa',
                        disabled: true,
                    },
                    {
                        name: 'L',
                        points: [[0, 0], [0, 1], [0, 2], [0, 3], [1, 3],],
                        mode: 'rot',
                        color: 'active bomb',
                        disabled: true,
                    },
                    {
                        name: 'creeper',
                        points: [[1, 1], [1, 2], [2, 1], [2, 2], [0, 0, '#f00'], [3, 0, '#f00'],],
                        mode: 'explode',
                        bg: '',
                        color: 'active bomb',
                        disabled: false,
                    },
                    {
                        name: 'point',
                        points: [[0, 0],],
                        mode: 'ball',
                        color: 'active doted',
                        disabled: false,
                        image: puzzleBg,
                        bg: this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '' + this.randomInteger(1, 4) + '',
                    },
                    {
                        name: 'heart',
                        points: [[0, 0], [0, 1], [1, 1], [1, 2], [2, 1], [2, 0],],
                        mode: 'rot',
                        color: '#f00',
                        disabled: true,
                    },
                ],
                figures: [],
                passThrough: false,
                speedup: false,
                speed: 0.05,
                score: 0,
                realScore: 0,
                highScore: 0,
                winScore: 4,
                showAnimation: false,
                timer: 0,
                showPartners: false,
                instructions: false,
                step: 1,
                finalWin: false,
                start: false,
                gameon: false,
                win: false,
                board: [],
                boardClass: [],
                preview: [],
                brickSize: 4,
                smartRandom: true,
                emptyColor: '',
                currentTime: '',
                currentMin: '00',
                currentSec: '00',
                img: {
                    puzzleBg,
                    Logo,
                    LogoHmar,
                    vokzalfin,
                    olimpfin,
                    tsumfin,
                    bibliofin,
                    parusfin,
                    facebookImg,
                    twitterImg,
                    betonomeshalka,
                    betonomeshalkastop
                },
                nameObject: [
                    'Вокзал «Південний» в Києві',
                    'НСК Олімпійський',
                    'ЦУМ',
                    'Національнy бібліотекy України ім. Вернадського',
                    'БЦ Парус'
                ],
                finScore: [
                    3, 4, 6, 8, 12
                ],
                pathToImg: myPathToImg || "assets/img/",
                path: window.location.href,
            }
        },
        components: {
            TetrisBoard, PerfectScrollbar
        },
        watch: {
            start: function (val) {
                if (val) {
                    this.newGame();
                    let el = this.$refs.boardControl;
                    el.focus();
                    // check it twice...
                    setTimeout(() => el.focus(), 500);
                    this.startTimer();
                } else {
                    this.stopTimer()
                }
            },

        },
        methods: {
            startTimer() {
                this.timer = setInterval(() => {
                    this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);
                    this.currentMin = this.currentTime.getMinutes();
                    if (this.currentMin < 10) this.currentMin = '0' + this.currentMin;
                    this.currentSec = this.currentTime.getSeconds();
                    if (this.currentSec < 10) this.currentSec = '0' + this.currentSec;
                }, 1000)
            },
            stopTimer() {
                clearTimeout(this.timer)
            },
            randomInteger(min, max) {
                // получить случайное число от (min-0.5) до (max+0.5)
                let rand = min - 0.5 + Math.random() * (max - min + 1);
                return Math.round(rand);
            },
            nextLevel() {
                if (this.step < 5) {
                    this.step += 1;
                    this.win = false;
                    this.start = true;
                    this.$nextTick(function () {
                        this.initFigures();
                        this.newGame();
                        this.$refs.board.style.backgroundPositionY = 0;
                        let el = this.$refs.boardControl;
                        el.focus();
                        // check it twice...
                        setTimeout(() => el.focus(), 500);
                    })
                } else {
                    this.finalWin = true;

                }

            },
            toggleFigures(e) {
                for (let f of this.figuresAll)
                    f.disabled = e.target.checked;
            },

            pause() {
                switch (this.state) {
                    case 'pause':
                        this.state = 'running';
                        this.calcSpeed();
                        break;
                    case 'running':
                        this.state = 'pause';
                        this.calcSpeed();
                        break;
                }
            },

            initBoard() {
                this.board.length = this.board.w * this.board.h;
                for (let i = 0; i < this.board.length; ++i) {
                    this.board[i] = this.emptyColor;
                }
                if (this.step === 1) {
                    for (let i = 2; i < 11; i++) {
                        this.board[(i - 1) + (this.board.h - 1) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - 1);
                    }
                    for (let i = 2; i < 11; i++) {
                        this.board[(i - 1) + (this.board.h - 2) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - 2);
                    }
                    for (let i = 2; i < 11; i++) {
                        this.board[(i - 1) + (this.board.h - 3) * this.board.w]= ' prev x'+(i - 1)+'y'+ (this.board.h - 3);
                    }
                    for (let i = 6; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 4) * this.board.w] = ' final background2';
                    }
                } else if (this.step === 2) {
                    for (let i = 1; i < 11; i++) {
                        this.board[(i - 1) + (this.board.h - 1) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - 1);
                    }
                    for (let i = 2; i < 10; i++) {
                        for (let j = 2; j < 5; j++)
                            this.board[(i - 1) + (this.board.h - j) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - j);
                    }
                    for (let i = 4; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 5) * this.board.w] = ' final background2';
                    }
                } else if (this.step === 3) {
                    for (let i = 1; i < 11; i++) {
                        this.board[(i - 1) + (this.board.h - 1) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 1);
                    }
                    for (let i = 2; i < 11; i++) {
                        for (let j = 2; j < 5; j++)
                            this.board[(i - 1) + (this.board.h - j) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - j);
                    }
                    for (let i = 3; i < 9; i++) {
                        this.board[(i - 1) + (this.board.h - 5) * this.board.w] = ' prev x'+(i - 1)+'y'+ (this.board.h - 5);
                    }
                    for (let i = 4; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 6) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 6);
                    }
                    for (let i = 5; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 7) * this.board.w] = 'final background2';
                    }
                }
                else if (this.step === 4) {
                    for (let i = 1; i < 11; i++) {
                        for (let j = 1; j < 4; j++)
                            this.board[(i - 1) + (this.board.h - j) * this.board.w] =  'prev x'+(i - 1)+'y'+ (this.board.h - j);
                    }
                    for (let i = 2; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 4) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 4);
                    }
                    for (let i = 3; i < 8; i++) {
                        for (let j = 5; j < 12; j++)
                            this.board[(i - 1) + (this.board.h - j) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - j);
                    }
                    for (let i = 3; i < 5; i++) {
                        this.board[(i - 1) + (this.board.h - 12) * this.board.w] = ' final background2';
                    }}
                else if (this.step === 5) {
                    for (let i = 3; i < 9; i++) {
                        this.board[(i - 1) + (this.board.h - 1) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 1);
                    }
                    for (let i = 3; i < 9; i++) {
                        this.board[(i - 1) + (this.board.h - 2) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 2);
                    }
                    for (let i = 3; i < 9; i++) {
                        this.board[(i - 1) + (this.board.h - 3) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 3);
                    }
                    for (let i = 4; i < 9; i++) {
                        this.board[(i - 1) + (this.board.h - 4) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 4);
                    }
                    for (let i = 4; i < 8; i++) {
                        for (let j = 5; j < 12; j++)
                            this.board[(i - 1) + (this.board.h - j) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - j);
                    }
                    for (let i = 5; i < 8; i++) {
                        this.board[(i - 1) + (this.board.h - 12) * this.board.w] =  ' prev x'+(i - 1)+'y'+ (this.board.h - 12);
                    }
                }


                //this.testBallBoard();
            },

            testBallBoard() {
                for (let y = this.board.h - 1; y > 5; y--) {
                    for (let x = 0; x < this.board.w; ++x)
                        if (x !== 5)
                            this.board[x + y * this.board.w] = '#080';
                }
                this.board[4 + 5 * this.board.w] = '#080';
                this.board[5 + 5 * this.board.w] = '#080';
                this.board[6 + 5 * this.board.w] = '#080';
                this.board[7 + 5 * this.board.w] = '#080';
            },

            initPreview() {
                this.preview.length = this.preview.w * this.preview.h;
                for (let i = 0; i < this.preview.length; ++i) {
                    this.preview[i] = this.emptyColor;
                }
            },

            initFigures() {
                for (let figure of this.figuresAll) {
                    let [x, y] = [0, 0];
                    if (!figure.anchor) {
                        for (let t of figure.points) {
                            x = Math.max(x, t[0]);
                            y = Math.max(y, t[1]);
                        }
                        figure.anchor = [x / 2, y / 2];
                    }
                    switch (figure.mode) {
                        case 'ball':
                        case 'explode':
                        case 'frozen':
                            figure.pointsRotated = [figure.points, figure.points, figure.points, figure.points];
                            break;
                        case 'rot':
                            figure.pointsRotated = [];
                            figure.pointsRotated.push(figure.points.map(p => [
                                Math.round(figure.anchor[0] + (p[0] - figure.anchor[0])),
                                Math.round(figure.anchor[1] + (p[1] - figure.anchor[1])),
                            ]));
                            figure.pointsRotated.push(figure.points.map(p => [
                                Math.round(figure.anchor[0] - (p[1] - figure.anchor[1])),
                                Math.round(figure.anchor[1] + (p[0] - figure.anchor[0])),
                            ]));
                            figure.pointsRotated.push(figure.points.map(p => [
                                Math.round(figure.anchor[0] - (p[0] - figure.anchor[0])),
                                Math.round(figure.anchor[1] - (p[1] - figure.anchor[1])),
                            ]));
                            figure.pointsRotated.push(figure.points.map(p => [
                                Math.round(figure.anchor[0] + (p[1] - figure.anchor[1])),
                                Math.round(figure.anchor[1] - (p[0] - figure.anchor[0])),
                            ]));
                            break;
                        case '90':
                            figure.pointsRotated = [];
                            figure.pointsRotated.push(figure.points.map(p => [
                                figure.anchor[0] + (p[0] - figure.anchor[0]),
                                figure.anchor[1] + (p[1] - figure.anchor[1]),
                            ]));
                            figure.pointsRotated.push(figure.points.map(p => [
                                figure.anchor[1] - (p[1] - figure.anchor[1]),
                                figure.anchor[0] + (p[0] - figure.anchor[0]),
                            ]));
                            break;
                        default:
                            throw 'unknown figure rotation mode: ' + figure.mode;
                    }
                }
            },

            setFigureToMap(map, figure, preview = false) {
                let [x, y] = preview
                    ? [
                        -figure.figure.anchor[0] + map.w / 2 | 0,
                        -figure.figure.anchor[1] + map.h / 2 | 0
                    ]
                    : [figure.pos[0], figure.pos[1]];
                let j = 0;
                for (let p of figure.figure.pointsRotated[figure.rotate]) {
                    let px = x + p[0];
                    let py = y + p[1];
                    if (px >= 0 && px < map.w && py >= 0 && py < map.h) {
                        if (!map[px + py * map.w].match('final')) {
                            map[px + py * map.w] = figure.color + ' background' + figure.figure.bg[j];
                        }
                        j++;
                        // classmap[px + py * map.w] = 'active';
                        // map[px + py * map.w] = figure.color;


                    }
                }
            },

            unsetFigureFromMap(map, figure, preview = false) {
                let [x, y] = preview
                    ? [
                        -figure.figure.anchor[0] + map.w / 2 | 0,
                        -figure.figure.anchor[1] + map.h / 2 | 0
                    ]
                    : [figure.pos[0], figure.pos[1]];

                [figure.pos[0], figure.pos[1]];
                for (let p of figure.figure.pointsRotated[figure.rotate]) {
                    let px = x + p[0];
                    let py = y + p[1];
                    if (px >= 0 && px < map.w && py >= 0 && py < map.h) {
                        map[px + py * map.w] = this.emptyColor;
                    }
                }
            },

            swapNew() {
                this.passThrough = false;
                this.current = this.next;
                if (this.checkCollide(this.board, this.current) || this.realScore >= this.finScore[this.step - 1])
                    return this.end();
                this.setFigureToMap(this.board, this.current);
                this.$refs.board.update();

                this.unsetFigureFromMap(this.preview, this.next, true);
                this.next = this.genNew()
                this.setFigureToMap(this.preview, this.next, true);
                this.$refs.preview.update();
                this.showAnimation = false;
            },

            genNew() {
                if (this.smartRandom) {
                    return this.genNewSmart();
                } else {
                    return this.genNewOld();
                }
            },

            genNewSmart() {
                let {bucket} = this;

                let fill = false;

                while (bucket[0] !== this.last) {
                    if (!bucket.length) {
                        this.fillBucket();
                        fill = true;
                    }

                    for (let i = 0; i < bucket.length - 1; ++i) {
                        if (bucket[0] !== this.last) break;
                        bucket.push(bucket.shift());
                    }

                    if (bucket[0] === this.last && !fill) {
                        bucket.length = 0;
                        continue;
                    }

                    break;
                }

                let figure = bucket.shift();

                let current = {
                    figure,
                    rotate: 0,
                };

                this.last = figure;

                current.color = figure.color ||
                    `hsl(${360 * Math.random() | 0}, 100%, 50%)`;

                current.bg = figure.bg;
                current.pos = [
                    this.board.w / 2 - figure.anchor[0] | 0,
                    0,
                ];

                return current;
            },

            fillBucket() {
                let {bucket, figures} = this;
                bucket.length = 0;

                /*this.bucket.push(this.figures[
                    Math.random()*this.figures.length|0
                ]);*/

                bucket.push(...figures);
                // make two sets in short
                bucket.push(...figures);

                for (let i = 0; i < bucket.length - 1; ++i) {
                    let available = bucket.length - i - 1;
                    let randPick = Math.random() * available | 0;
                    let j = i + randPick;
                    [bucket[i], bucket[j]] = [bucket[j], bucket[i]];
                }
            },

            genNewOld() {
                let current = {};
                current.figure = this.figures[
                Math.random() * this.figures.length | 0
                    ];
                current.rotate = 0;
                current.color = current.figure.color ||
                    `hsl(${360 * Math.random() | 0}, 100%, 50%)`;

                current.bg = current.figure.bg;
                current.pos = [this.board.w / 2 - current.figure.anchor[0] | 0, 0];
                return current;
            },
            moveDown() {
                this.speedup = true;
                setTimeout(() => {
                    this.speedup = false;
                    this.calcSpeed();
                }, 150)
                this.calcSpeed();
                this.loop();
            },
            keydown(e) {
                switch (e.which) {
                    case 'N'.charCodeAt(0):
                        this.newGame();
                        break;
                    case 'P'.charCodeAt(0):
                        this.pause();
                        break;
                    case 37: // left
                        this.move(-1);
                        break;
                    case 39: // right
                        this.move(1);
                        break;
                    case 38: // up
                        if (this.start) e.preventDefault();
                        this.rotate(1);
                        break;
                    case 13:
                        this.rotate(1);
                        break;
                    case 40: // down
                        if (this.start) e.preventDefault();
                        if (!e.repeat && this.state === 'running') {
                            this.speedup = true;
                            this.calcSpeed();
                            this.loop();
                        }
                        break;
                }
            },

            keyup(e) {
                switch (e.which) {
                    case 40: // down
                        if (!e.repeat) {
                            this.speedup = false;
                            this.calcSpeed();
                        }
                        break;
                }
            },

            move(x) {
                if (this.state !== 'running' || this.passThrough)
                    return;
                this.unsetFigureFromMap(this.board, this.current);
                this.current.pos[0] += x;
                let check = this.checkCollide(this.board, this.current);
                if (check === 0) {
                    this.setFigureToMap(this.board, this.current);
                    this.$refs.board.update();
                } else {
                    if (check !== 2 && this.current.figure.mode === 'explode')
                        return this.explode();
                    this.current.pos[0] -= x;
                    this.setFigureToMap(this.board, this.current);
                }
            },

            rotate(dir) {
                if (this.state !== 'running')
                    return;
                if (this.current.figure.mode === 'explode')
                    return this.explode();
                this.unsetFigureFromMap(this.board, this.current);
                let n = this.current.figure.pointsRotated.length;
                this.current.rotate = (n + (this.current.rotate + dir)) % n;
                let check = this.checkCollide(this.board, this.current);
                if (check === 0) {
                    this.setFigureToMap(this.board, this.current);
                    this.$refs.board.update();
                } else {
                    this.current.rotate = (n + (this.current.rotate - dir)) % n;
                    this.setFigureToMap(this.board, this.current);
                }
            },

            calcSpeed() {
                if (this.intervalId !== null)
                    clearInterval(this.intervalId);
                if (this.state === 'running') {
                    let delay = 50 + (1000 - 50) * (1 - (this.speedup ? 12 : this.speed) / 12);
                    this.intervalId = setInterval(this.loop.bind(this), delay);
                } else {
                    this.intervalId = null;
                }
            },

            loop() {
                if (!this.passThrough)
                    this.unsetFigureFromMap(this.board, this.current);
                this.current.pos[1] += 1;
                let check = this.checkCollide(this.board, this.current);
                if (check === 0) {
                    this.setFigureToMap(this.board, this.current);
                    // if (this.current.figure.mode === 'ball') {
                    //     this.passThrough = false;
                    //     this.discardBuilded(this.board);
                    //     this.setFigureToMap(this.board, this.current);
                    // }
                    if (this.$refs.board) this.$refs.board.update();
                } else {
                    if (this.current.figure.mode === 'explode') return this.explode();
                    // if (this.current.figure.mode === 'ball' && check === 1 && this.checkDownFree()) {
                    //     this.passThrough = true;
                    //     this.setFigureToMap(this.board, this.current);
                    //     this.$refs.board.update();
                    //     return;
                    // }
                    this.current.pos[1] -= 1;
                    this.setFigureToMap(this.board, this.current);
                    this.discardBuilded(this.board);
                    if (this.$refs.board) this.$refs.board.update();
                    this.swapNew();


                    if (this.speedup) {
                        this.speedup = false;
                        this.calcSpeed();
                    }
                }
            },

            checkDownFree() {
                for (let y = this.current.pos[1] + 1; y < this.board.h; ++y)
                    if (this.board[this.current.pos[0] + y * this.board.w] === this.emptyColor)
                        return true;
                return false;
            },

            end() {
                this.highScore = Math.max(this.score, this.highScore);
                this.state = 'end';
                this.calcSpeed();
                if (this.realScore >= this.finScore[this.step - 1]) this.win = true;
                else this.win = false;
                this.start = false;
            },

            checkCollide(map, current) {
                for (let t of current.figure.pointsRotated[current.rotate]) {
                    let x = current.pos[0] + t[0];
                    let y = current.pos[1] + t[1];

                    if (x < 0 || x >= map.w || y < 0 || y >= map.h) {
                        if (y >= map.h)
                            current.color = 'final';
                        // this.setFigureToMap(this.board, this.current);
                        return 2;
                    }
                    if (map[x + y * map.w] !== this.emptyColor) {
                        current.color = 'final';
                        // this.setFigureToMap(this.board, this.current);
                        return 1;
                    }
                }
                return 0;
            },

            discardBuilded(map) {
                for (let y = map.h - 1; y >= 0; --y) {
                    let target = y;
                    let rbBg = false;
                    while (target >= 0) {
                        let n = 0;
                        for (let x = 0; x < map.w; ++x) {
                            if (map[x + target * map.w] !== this.emptyColor)
                                ++n;
                        }
                        if (n !== map.w)
                            break;
                        for (let x = 0; x < map.w; ++x) {
                            if (map[x + target * map.w].match('.prev'))
                                rbBg = true;
                        }
                        --target;
                        ++this.score;
                        if (rbBg) {
                            ++this.realScore;
                        }
                        rbBg = false;
                    }
                    if (target !== y) {
                        let sh = y - target;
                        for (let j = y; j >= sh; --j) {
                            for (let x = 0; x < map.w; ++x) {
                                map[x + j * map.w] = map[x + (j - sh) * map.w];
                            }
                        }
                    }
                }
            },

            newGame() {
                this.figures = this.figuresAll.filter(f => !f.disabled);
                if (!this.figures.length)
                    return alert('no figures selected');
                this.board.w = +this.board.w;
                this.board.h = +this.board.h;
                this.state = 'end';
                this.bucket = [];
                this.last = null;
                this.calcSpeed();
                this.initBoard();
                this.initPreview();

                this.highScore = Math.max(this.realScore, this.highScore);
                this.score = 0;
                this.realScore = 0;
                this.state = 'running';
                this.current = this.genNew();
                this.setFigureToMap(this.board, this.current);
                this.next = this.genNew();
                this.setFigureToMap(this.preview, this.next, true);
                this.intervalId = null;
                this.calcSpeed();
                this.loop();

                if (this.$refs.preview) this.$refs.preview.update();
            },

            showSettings() {
                this.state = 'settings';
                this.calcSpeed();
            },

            explode() {
                for (let x = 0; x < 4; ++x) {
                    for (let y = 0; y < 4; ++y) {
                        let xe = x + this.current.pos[0];
                        let ye = y + this.current.pos[1];
                        if (xe >= 0 && xe < this.board.w && ye >= 0 && ye < this.board.h && !this.board[xe + ye * this.board.w].match('prev'))
                            this.board[xe + ye * this.board.w] = this.emptyColor;
                    }
                }
                this.$refs.board.update();
                this.swapNew();
            },

        },

        created() {
            this.board.w = 10;
            this.board.h = 18;
            this.preview.w = 4;
            this.preview.h = 4;
            this.initFigures();
            // this.newGame();
        },

        mounted() {
            this.currentTime = new Date();
            this.currentTime.setHours(0, 0, 0);
        }
    }
</script>

<style scoped>

</style>